var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoubleQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#double-quote_svg__clip0_1556_37660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.36 20c3.437 0 5.703-2.42 5.703-5.196 0-2.99-1.9-4.91-5.19-4.91-.658 0-1.17.142-1.536.355.146-3.274 3.217-5.48 5.995-5.907V0C6.726.427 0 3.63 0 13.167 0 16.94 2.486 20 6.36 20zm14.604 0c3.436 0 5.703-2.42 5.703-5.196 0-2.99-1.901-4.91-5.191-4.91-.658 0-1.17.142-1.536.355.147-3.274 3.217-5.48 5.996-5.907V0c-4.607.427-11.333 3.63-11.333 13.167 0 3.773 2.486 6.833 6.36 6.833h.001z",
    fill: "#2C70E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "double-quote_svg__clip0_1556_37660"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v20H0z"
  })))));
}

export default SvgDoubleQuote;